// Measurement
export const DEFAULT_MEASUREMENT_STATISTICAL_SIGNIFICANCE_THRESHOLD = 80